export default __webpack_public_path__ + "static/media/logo.90c2281d.svg";